export default __webpack_public_path__ + "static/clustersetup3-74fd33b85b239969b7208612823ce1f1.png";